"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _client = require("react-dom/client");
var _GlobalFunctions = _interopRequireDefault(require("GlobalFunctions"));
var _Application = _interopRequireDefault(require("Application"));
var _styles = require("@mui/material/styles");
var _ajaxRequest = _interopRequireDefault(require("Functions/ajax/ajaxRequest"));
var _Routing = require("Functions/Routing");
var _config = _interopRequireDefault(require("Shared/config"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const theme = (0, _styles.createTheme)({
  typography: {
    fontFamily: 'inherit'
  },
  palette: {
    primary: {
      main: '#5EBDE7'
    },
    secondary: {
      main: '#5EA761'
    },
    error: {
      main: '#C00506'
    },
    warning: {
      main: '#E49201'
    },
    info: {
      main: '#0E7DD5'
    },
    success: {
      main: '#63998D'
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 992,
      lg: 1200,
      xl: 1536
    }
  }
});
document.addEventListener('DOMContentLoaded', function () {
  var _ErrorBoundary;
  const container = document.getElementById('app');
  if (!container) return console.error('missing #app <div> on the page');
  window.app.recovery_errors_count = 0;
  const CrashHandler = (_ErrorBoundary = class ErrorBoundary extends _react.Component {
    constructor() {
      super(...arguments);
      (0, _defineProperty2.default)(this, "state", {});
      (0, _defineProperty2.default)(this, "count", 0);
    }
    render() {
      return this.props.children;
    }
  }, (0, _defineProperty2.default)(_ErrorBoundary, "getDerivedStateFromError", error => {
    var _window$app$state$ses;
    const component = _ErrorBoundary,
      props = _ErrorBoundary.props,
      state = _ErrorBoundary.state;
    console.info('derived');
    if (error.toString() === component.current_error) return {};
    sendError(error);
    component.current_error = error.toString();
    let redirection = '/';
    window.localStorage.setItem('critical_front_error', 'true');
    if ((_window$app$state$ses = window.app.state.session.user) !== null && _window$app$state$ses !== void 0 && _window$app$state$ses.id) {
      redirection = (0, _Routing.URL)(_config.default.default_home);
    }

    // start tab/window + first page = 2, check if previous page is same app
    if (window.history.length > 2 && window.referrer === document.location.origin) {
      return window.history.back();
    } else if (redirection === document.location.pathname) {
      document.body.innerHTML = ['<p>', 'L\'application vient de rencontrer une erreur critique et n\'a pas pu afficher la page.', '</p>', '<p>', 'Notre équipe en a été informée. En attendant notre intervention, essayez de vider vos cookies et de recharger la page.', '</p>'].join('');
      document.body.style.padding = '10px 20px';
      return {};
    }
    console.info('redirecting', redirection);
    document.location.href = redirection;
    return {};
  }), _ErrorBoundary);
  const root = (0, _client.createRoot)(container);
  startApp();
  window.addEventListener('unhandledrejection', _ref => {
    let {
      reason
    } = _ref;
    return console.error('unhandled rejection', reason);
  });
  function startApp() {
    let recovery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (recovery) console.log('App recovery');
    const has_error = recovery === true ? true : window.localStorage.getItem('critical_front_error') === 'true';
    window.localStorage.removeItem('critical_front_error');
    root.render( /*#__PURE__*/_react.default.createElement(_styles.StyledEngineProvider, {
      injectFirst: true
    }, /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
      theme: theme
    }, /*#__PURE__*/_react.default.createElement(_Application.default, {
      error: has_error
    }))));
  }
  async function sendError(error) {
    try {
      await (0, _ajaxRequest.default)((0, _Routing.action)('CriticalFrontError'), {
        data: {
          error: JSON.stringify(error, Object.getOwnPropertyNames(error)),
          url: document.location.pathname
        }
      });
    } catch (req_error) {
      console.error(req_error);
    }
  }
});
